// Sign in. Rendered bare -- the Studio's masthead is hidden while signed
// out (components/shell/UserShell.tsx), so this is the one page that is
// just a card on paper.
import { useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { ApiError } from "../api/client";

export default function Login() {
  const { user, signIn } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (user) {
    const from = (location.state as { from?: Location })?.from;
    return <Navigate to={from?.pathname ?? "/"} replace />;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "sign in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="u-login">
      <form className="u-login__card" onSubmit={(e) => void onSubmit(e)}>
        <div className="u-login__word">gpu-fan</div>
        {/* The sub is set in capitals with wide tracking, so it is a tagline
            rather than a sentence -- no copy here should be longer than this. */}
        <p className="u-login__sub">Photo in · video out</p>
        <label className="u-field">
          Email
          <input
            className="u-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label className="u-field">
          Password
          <input
            className="u-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {error && <p className="u-error">{error}</p>}
        <button className="u-btn u-btn--solid u-btn--wide" type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p className="u-login__note">Accounts are created by an admin (ADR-0015).</p>
      </form>
    </div>
  );
}
